import * as tslib_1 from "tslib";
import { ODataGridComponent, urlStateHandler, } from '@pages/generics/grid';
import cloneDeep from 'lodash-es/cloneDeep';
import { take } from 'rxjs/operators';
import { EnvironmentModalComponent, EnvironmentRobotsModalComponent, } from './modals';
var ɵ0 = urlStateHandler;
var EnvironmentsPageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(EnvironmentsPageComponent, _super);
    function EnvironmentsPageComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._openEnvironmentModal = function (data) {
            _this._grid.dataManager
                .data$
                .pipe(take(1))
                .subscribe(function () {
                _this._refresh$.next();
                _this.showEnvironment(data);
            });
        };
        return _this;
    }
    EnvironmentsPageComponent.prototype.openModal = function (model) {
        var _this = this;
        var clone;
        if (model) {
            clone = cloneDeep(model);
        }
        this._modal
            .openModal(EnvironmentModalComponent, clone)
            .afterClosedResult()
            .subscribe(function (res) {
            switch (res.type) {
                case 1 /* Add */:
                    _this._openEnvironmentModal(res.data);
                    break;
                case 2 /* Update */:
                    _this._refresh$.next();
                    break;
            }
        });
    };
    EnvironmentsPageComponent.prototype.showEnvironment = function (entry) {
        this._modal.openModal(EnvironmentRobotsModalComponent, cloneDeep(entry), {
            autoFocus: false,
        });
    };
    return EnvironmentsPageComponent;
}(ODataGridComponent));
export { EnvironmentsPageComponent };
export { ɵ0 };
